import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptsModule } from '../../../modules/scripts.module';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.css']
})
export class DetalleComponent implements OnInit {

  public promocion;
  constructor(private route: ActivatedRoute,private router: Router) { }

  ngOnInit() {
    let scripts = new ScriptsModule;
    scripts.loadScript('assets/js/scripts/promociones-detalle.js');           
          this.route.params.subscribe(params => {     
              
            this.promocion = params['id']; // (+) converts string 'id' to a number
              
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/promociones/detalle/detalle.component.ts